<template>
<div class="col-12 px-0"> 
    <el-table
        :data="tableData"
        ref="multipleTable"
        style="width: 100%"
        id="table-company-group"
        :class="getPrimaryColor"
    >

        <el-table-column prop="provider" sortable :sort-method="sortColumnName" :label="!USER_TYPE_MIXIN.isBackOffice ? 'fornecedor' : 'cedente'" min-width="80">
            <template slot-scope="scope">
                <div class="d-flex align-items-center">
                    <NameInitials :name="scope.row.name" small/>
                    <el-tooltip class="item" :content="scope.row.name | formatName" placement="top">
                        <span class="break-name c-ndarkfour medium">
                            {{ (scope.row.tradingName || scope.row.name) | formatName }}
                        </span>
                    </el-tooltip>
                </div>
            </template>
        </el-table-column>

        <el-table-column prop="cnpj" sortable :sort-method="sortColumnCnpj" label="cnpj" min-width="60">
            <template slot-scope="scope">
                <span class="c-ndarkfour medium">
                    {{ scope.row.cnpj.cnpj | formatCnpjOrCpf }}
                </span>
            </template>
        </el-table-column>

        <el-table-column prop="orderFomentationRequest" sortable :sort-method="sortColumnStatus" label="cadastro" min-width="60">
            <template slot-scope="scope">
                <CompanyStatus :status="scope.row.cnpj.registerComplete" />
            </template>
        </el-table-column>

        <el-table-column prop="orderFomentationRequest" min-width="120">
            <template slot-scope="scope">
                <div class="d-flex justify-content-end align-items-center">
                    <el-dropdown trigger="click">
                        <Button size="small" :color="getPrimaryColor">Ações</Button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item >
                                <router-link :class="`${getPrimaryColor} c-ndarkthree medium`" :to="`/group/${$route.params.groupId}/provider/${scope.row.id}/setting`">
                                    <Settings />Regras da operação
                                </router-link>
                            </el-dropdown-item>
                            <el-dropdown-item >
                                <div @click="handleDeleteProvider(scope.row.id)" class="c-sredfour medium pl-3 d-flex align-items-center">
                                    <Trash class="mr-2" color="#E54949"/>Excluir
                                </div>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </template>
        </el-table-column>
    </el-table>
    <BuyerProviderGroupDelete :provider="true" :dialogVisible="dialogVisible" @closeModal="dialogVisible = $event" @delete="requestDelete"/>
</div>
</template>

<script>
import BuyerProviderGroupDelete from '@/components/modals/BuyerProviderGroupDelete'
import NameInitials from '@/components/icons/NameInitials'
import CompanyStatus from '@/components/status/CompanyStatus'
import Trash from '@/components/icons/Trash.vue'
import Settings from '@/components/icons/Settings'
import deleteProviderEconomicGroup from '@/api/deleteProviderEconomicGroup'
export default {
    props: {
        tableData: {
            required: true
        },
    },
    components: {
        BuyerProviderGroupDelete,
        NameInitials,
        CompanyStatus,
        Trash,
        Settings
    },
    data() {
        return {
            dialogVisible: false,
            providerIdToDelete: ''
        }
    },
    methods: {
        sortColumnCnpj(a, b) {
            return parseInt(a.cnpj.cnpj) - parseInt(b.cnpj.cnpj)
        },
        sortColumnStatus(a, b) {
            return a.cnpj.registerComplete - b.cnpj.registerComplete
        },
        sortColumnName(a, b) {
            return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
        },
        handleDeleteProvider(id) {
            this.dialogVisible = true
            this.providerIdToDelete = id
        },
        async requestDelete() {
            const result = await deleteProviderEconomicGroup(this.$route.params.groupId, { providerIds: [this.providerIdToDelete]})
            if (result.data.ok) {
                this.$emit('providerDeleted')
            }
            this.dialogVisible = false
        }
    },
}
</script>

<style lang="scss" scoped>
.el-table .el-table__body-wrapper .el-table__body tbody .el-table__row td .cell .el-dropdown {
    text-align: end !important;
}
</style>